// extracted by mini-css-extract-plugin
module.exports = {"newsfeed":"Lf-z"};